module.exports = __webpack_public_path__ + "static/media/blank_profile.d56f3185.svg";